import { Header } from './components/Header';
import { Footer } from './components/Footer';
import FileUpload from './components/FileUpload';
import ShoppingCart from './components/ShoppingCart';
import { ThemeProvider } from './components/ThemeProvider';
import siteConfig from './config/siteConfig';
import './styles/globals.css';

function App() {
  document.title = siteConfig.site.name;

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-gray-900 text-white flex flex-col">
        <Header className="mb-0" />
        <main className="flex-1 container mx-auto px-4 mt-4">
          <FileUpload />
        </main>
        <ShoppingCart />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
